import React from 'react';
import { CtaBlock } from '../../components/CtaBlock';
import { Footer } from '../../components/Footer';
import { Header } from '../../components/Header';
import { HeaderPage } from '../../components/HeaderPage';
import './style.css';

export const ImpressumDesktop = ({
    shareFeedbackEmailAddress: shareFeedbackEmailAddress,
}) => {
    return (
        <div className="impressum-desktop">
            <Header
                className="design-component-instance-node-3"
                style="desktop"
                shareFeedbackEmailAddress={shareFeedbackEmailAddress}
                logoDimensions={{
                    height: 64 * 1.8 + 'px',
                    width: 104 * 1.8 + 'px',
                }}
            />
            <HeaderPage
                align="left"
                background="default"
                breadcrumbLinkText="Impressum"
                breakpoint="desktop"
                className="header-page-2"
                text=""
                title="Impressum"
            />
            <div className="content-wrapper">
                <div className="content-4">
                    <div className="div-7">
                        <div className="div-8">
                            <div className="text-wrapper-11">
                                Allgemeine Informationen gem. § 5 TMG, § 55
                                RStVG{' '}
                            </div>
                            <p className="text-wrapper-12">
                                Universität Tübingen, Tübingen Center for
                                Digital Education
                                <br />
                                Prof. Dr. Andreas Lachner
                                <br />
                                Wilhelmsstraße 31
                                <br />
                                72074 Tübingen
                                <br />
                                Telefon:+49 (0) 7071 29-77454
                                <br />
                                Email: andreas.lachner@uni-tuebingen.de
                                <br />
                            </p>
                        </div>
                    </div>
                    <div className="div-9">
                        <div className="video-wrapper"></div>
                    </div>
                </div>
            </div>
            <div className="content-wrapper">
                <div className="content-5" style={{ marginTop: '-80px' }}>
                    <div className="div-10">
                        <div className="div-11">
                            <p className="text-wrapper-11">Externe Links </p>
                            <p className="text-wrapper-12">
                                Diese Webseite des Tübingen Center for Digital
                                Education (TüCeDE)enthält entsprechend
                                gekennzeichnete Links oder Verweise auf Websites
                                Dritter. Durch den Link vermittelt das TüCeDE
                                lediglich den Zugang zur Nutzung dieser Inhalte.
                                Eine Zustimmung zu den Inhalten den verlinkten
                                Seiten Dritter ist damit nicht verbunden. Das
                                TüCeDE übernimmt daher keine Verantwortung für
                                die Verfügbarkeit oder den Inhalt solcher
                                Websites und keine Haftung für Schäden oder
                                Verletzungen, die aus der Nutzung – gleich
                                welcher Art – solcher Inhalte entstehen. Hierfür
                                haftet allein der Anbieter der jeweiligen Seite.
                            </p>
                            <p className="text-wrapper-12">
                                Bei der erstmaligen Verknüpfung mit einem
                                anderen Internetangebot hat die Redaktion dessen
                                Inhalt daraufhin überprüft, ob durch ihn eine
                                mögliche zivilrechtliche oder strafrechtliche
                                Verantwortlichkeit ausgelöst wird. Dort
                                nachträglich eingebundene Inhalte können jedoch
                                leider nicht überprüft werden. Der Verweis auf
                                dieses Angebot wird unverzüglich aufgehoben
                                werden, sobald die Redaktion feststellt oder von
                                anderen darauf hingewiesen wird, dass ein
                                bestimmtes Angebot, zu dem ein Link
                                bereitgestellt wurde, eine zivil- oder
                                strafrechtliche Verantwortlichkeit auslöst.
                            </p>
                        </div>
                    </div>

                    <div className="div-10">
                        <div className="div-11">
                            <p className="text-wrapper-11">Urheberrecht</p>
                            <p className="text-wrapper-12">
                                Alle auf dieser Website veröffentlichten Inhalte
                                (Layout, Texte, Bilder, Grafiken, Video- und
                                Tondateien usw.) unterliegen dem Urheberrecht.
                                Jede vom Urheberrechtsgesetz nicht zugelassene
                                Verwertung bedarf vorheriger ausdrücklicher
                                Zustimmung des TüCeDE. Dies gilt insbesondere
                                für Vervielfältigung, Bearbeitung, Übersetzung,
                                Einspeicherung, Verarbeitung bzw. Wiedergabe von
                                Inhalten in Datenbanken oder anderen
                                elektronischen Medien und Systemen. Fotokopien
                                und Downloads von Web-Seiten für den privaten,
                                wissenschaftlichen und nicht kommerziellen
                                Gebrauch dürfen hergestellt werden. Bilder von
                                externen Quellen sind mit entsprechendem Hinweis
                                auf den Urheber versehen.
                            </p>
                            <p className="text-wrapper-12">
                                Auf dieser Webseite werden OER Materialien
                                veröffentlicht oder verlinkt. Alle OER
                                Materialien sind mit ihrer eigenen offenen
                                Lizenz veröffentlicht und dürfen nur unter den
                                entsprechenden Bedingungen benutzt werden.
                            </p>
                        </div>
                    </div>

                    <div className="div-10">
                        <div className="div-11">
                            <p className="text-wrapper-11">
                                Haftungsausschluss
                            </p>
                            <p className="text-wrapper-12">
                                Die Informationen auf dieser Website wurden nach
                                bestem Wissen und Gewissen sorgfältig
                                zusammengestellt und geprüft. Es wird jedoch
                                keine Gewähr – weder ausdrücklich noch
                                stillschweigend – für die Vollständigkeit,
                                Richtigkeit oder Aktualität sowie die
                                jederzeitige Verfügbarkeit der bereit gestellten
                                Informationen übernommen. Eine Haftung für
                                Schäden, die aus der Nutzung oder Nichtnutzung
                                der auf dieser Website angebotenen Informationen
                                entstehen ist – soweit gesetzlich zulässig –
                                ausgeschlossen.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer
                className="design-component-instance-node-3"
                property1="desktop"
            />
        </div>
    );
};
